import { useMemo, ReactNode } from 'react';

// material-ui
import { CssBaseline, StyledEngineProvider } from '@mui/material';
import { createTheme, ThemeOptions, ThemeProvider, Theme } from '@mui/material/styles';

// project import
import Palette from './palette';
import Typography from './typography';
import useConfig from 'hooks/useConfig';

import componentStyleOverrides from './compStyleOverride';

// types
import { TypographyOptions } from '@mui/material/styles/createTypography';

interface Props {
    children: ReactNode;
}

export default function ThemeCustomization({ children }: Props) {
    const { fontFamily } = useConfig();
    const theme: Theme = useMemo<Theme>(() => Palette(), []);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const themeTypography: TypographyOptions = useMemo<TypographyOptions>(() => Typography(theme, fontFamily), [theme, fontFamily]);

    const themeOptions: ThemeOptions = useMemo(
        () => ({
            palette: theme.palette,
            mixins: {
                toolbar: {
                    minHeight: '48px',
                    padding: '16px',
                    '@media (min-width: 600px)': {
                        minHeight: '48px'
                    }
                }
            },
            typography: themeTypography
        }),
        [theme, themeTypography]
    );

    const themes: Theme = createTheme(themeOptions);
    themes.components = useMemo(() => componentStyleOverrides(themes), [themes]);

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={themes}>
                <CssBaseline />
                {children}
            </ThemeProvider>
        </StyledEngineProvider>
    );
}
